// @ts-nocheck
/*
 * Port of sms-webhook/components/apiBuilderUtils.js (187 lines).
 * BYTE-IDENTICAL — cURL parser (handles -X / -G / --data* variants incl.
 * --data-urlencode, escaped multiline, %27 trailing quotes), recursive
 * parseNestedStrings for JSON strings inside parsed body values, and a JSON
 * syntax highlighter that matches ApiBuilder.css class names.
 */
export const parseCurl = (curl) => {
  try {
    if (!curl || typeof curl !== 'string') {
      return { url: '', method: 'GET', headers: {}, body: '' };
    }

    curl = curl
      .replace(/ /g, ' ')
      .replace(/​/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/\\\r?\n/g, ' ')
      .trim();

    const urlMatch = curl.match(/(https?:\/\/[^\s'"]+)/i);
    let url = urlMatch ? urlMatch[1] : '';

    if (url) {
      url = url.replace(/(['%27]+)$/g, '');
      try {
        url = decodeURIComponent(url);
      } catch {
        // ignore
      }
    }

    let method = 'GET';
    const methodMatch = curl.match(/-X\s+(\w+)/i);
    if (methodMatch) method = methodMatch[1].toUpperCase();

    if (/\s-G\s/.test(curl)) method = 'GET';

    const hasDataFlag =
      /\s(--data|-d|--data-raw|--data-binary|--form|-F|--data-urlencode)\s+/.test(curl);
    if (!methodMatch && !/\s-G\s/.test(curl) && hasDataFlag) method = 'POST';

    const headers = {};
    const headerMatches = [...curl.matchAll(/(?:-H|--header)\s+['"]?([^'"\n]+)['"]?/gi)];
    headerMatches.forEach((m) => {
      const headerLine = m[1].trim();
      const [key, ...rest] = headerLine.split(':');
      if (key && rest.length) headers[key.trim()] = rest.join(':').trim();
    });

    const dataFlags = ['-d', '--data', '--data-raw', '--data-binary', '--form', '-F'];
    let body = '';

    for (const flag of dataFlags) {
      const matchQuoted = curl.match(new RegExp(`${flag}\\s+(['"])([\\s\\S]*?)\\1`));
      if (matchQuoted) {
        body = matchQuoted[2].trim();
        break;
      }
      const matchUnquoted = curl.match(new RegExp(`${flag}\\s+([^\\s]+)`));
      if (matchUnquoted) {
        body = matchUnquoted[1].trim();
        break;
      }
    }

    const params: string[] = [];
    const urlEncodeRegex = /--data-urlencode\s+(?:'([^']+)'|"([^"]+)"|([^\s]+))/gi;
    let encoded;
    while ((encoded = urlEncodeRegex.exec(curl)) !== null) {
      const param = encoded[1] || encoded[2] || encoded[3];
      params.push(param.trim());
    }

    if (method === 'GET' && params.length) {
      const query = params.join('&');
      url += (url.includes('?') ? '&' : '?') + query;
    }

    if (body && method !== 'GET') {
      try {
        const parsedBody = JSON.parse(body);
        body = JSON.stringify(parsedBody);
      } catch {
        // keep as-is
      }
    }

    return { url, method, headers, body };
  } catch (error) {
    console.error('Error parsing curl:', error);
    return { url: '', method: 'GET', headers: {}, body: '' };
  }
};

export function parseNestedStrings(obj) {
  if (typeof obj === 'string') {
    const trimmed = obj.trim();
    if (!(trimmed.startsWith('{') || trimmed.startsWith('['))) {
      return obj;
    }
    try {
      const parsed = JSON.parse(trimmed);
      return parseNestedStrings(parsed);
    } catch {
      return obj;
    }
  }

  if (Array.isArray(obj)) {
    return obj.map(parseNestedStrings);
  }

  if (obj && typeof obj === 'object') {
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, parseNestedStrings(v)]));
  }

  return obj;
}

export const syntaxHighlight = (json) => {
  if (typeof json !== 'string') {
    json = JSON.stringify(json, null, 2);
  }
  json = json
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|\b-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?\b)/g,
      (match) => {
        let cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return `<span class="${cls}">${match}</span>`;
      },
    );
  return json;
};

export function safeJsonParse(input) {
  if (!input) return { ok: true, value: {} };
  try {
    return { ok: true, value: JSON.parse(input) };
  } catch (e) {
    return { ok: false, error: e };
  }
}

export function convertKeyValueArrayToObject(arr) {
  if (!Array.isArray(arr)) return {};
  return arr.reduce((acc, item) => {
    const key = item?.key?.trim();
    if (!key) return acc;
    acc[key] = item?.value ?? '';
    return acc;
  }, {} as any);
}
